var spot = {
	init: function(){
		//console.log("%cSPOT init", 'color: #6feb00');
		let $spot = $("#spot"),
			$body = $("body");
		
		//デッキ > スポットに来た時、リセットする
		cardview.current = 0;

		if( $body.hasClass("is_spot_detail") && $spot.hasClass("show")){
			//初回のときも読み込むので振り分けたい
			if( $spot.hasClass("first") ){
				$spot.removeClass("first");
				mapApi.init();
				spotSlide.init();
				setTimeout(function(){
					common.scrollToPosition(0, 0);
					common.closeLoading().done(function(){
						fw.afterChangePage();
					});
				}, 100);
			}else{
				loadSpot();
			}
		}else{
			$spot.addClass("disable");
			setTimeout(function(){
				//別ページからスポットに来たとき
				if( !$spot.hasClass("show") ){
					$spot.addClass("show");
					$spot.off().on(transitionEndEvents, function(){
						$spot.off();
						setTimeout(function(){
							loadSpot();
						}, 50);
					});
				}else{
					setTimeout(function(){
						loadSpot();
					}, 400);
				}
			},400);
		}

		function loadSpot(){
			loadPage.loadSpot().done(function(){
				mapApi.init();
				spotSlide.init();
				console.log("here")
				common.scrollToPosition(0, 50);
				setTimeout(function(){
					$body.addClass("is_spot_detail");
					$body.removeClass("scroll_deck");
					common.closeLoading().done(function(){
						fw.afterChangePage();
					});
				}, 100);
			});
		}
	},
	hideSpotDetail: function(){
		//console.log("%cHide SPOT Detail", 'color: #6feb00');
		let $spot = $("#spot"),
			$body = $("body");
		let posY = $(document).scrollTop()*-1;

		$(".wrap_slideshow").each(function(i){
			clearInterval(spotslides[i].timer);
		});
		if( $spot.hasClass("show") ){
			$spot.addClass("fixed");
			$("#spot #load_spot").css("transform", "translate3d(0, " + posY + "px, 0)");
			
			$spot.removeClass("show");
			setTimeout(function(){
				$body.removeClass("is_spot_detail");
				setTimeout(function(){
					$spot.removeClass("fixed");
					$("#spot #load_spot").css("transform", "");
				}, 600);
			},50);
		}
	},
	nav: function(){
		$("#congestion").off().on("change", function(){
			spot.changeCongestion();
		});
	},
	changeCongestion: function(){
		let data = $("#congestion option:selected").attr("data-arry");
		let arry = data.split(",");

		if(data === ""){
			$(".congestion_graph ul li").each(function(i){
				$(this).find("span").css("height", "0%")
			});
			$(".block_congestion").addClass("disable");
		}else{
			if( $(".block_congestion").hasClass("disable") ){
				$(".block_congestion").removeClass("disable");
			}
			$(".congestion_graph ul li").each(function(i){
				$(this).find("span").css("height", arry[i] + "%")
			});
		}
	}
}
var Sslide = {
	current: 0,
	max: 0,
	timer: ""
}
var spotslides = [];
var spotSlidetimer;
var spotSlide = {
	duration: 5000,
	init: function(){
		//console.log("spot slideshow")
		spotslides = [];
		$(".wrap_slideshow").each(function(i){
			let _s = object(spotSlide);
			_s.current = 0;
			_s.max = $(this).find(".slideshow li").length;
			spotslides.push(_s);
		});
//		console.log(spotslides)
		spotSlide.resize();
		spot.nav();
		hstry.load();
		spotSlide.nav();
		recommendSlide.init();
		let hasArry = false;
		$("#congestion option").each(function(){
			let thisarry = $(this).attr("data-arry");
			if(thisarry != ""){
				hasArry = true;
			}
		});
		if(hasArry){
			spot.changeCongestion();
		}else{
			$(".block_congestion").remove();
		}
		
		setTimeout(function(){
			spotSlide.resize();
		}, 600);
		if($(".wrap_slideshow").length > 0){
			$(".wrap_slideshow").each(function(j){
				spotSlide.change(j);
			});
		}
	},
	resize: function(){
		$("#spot .wrap_slideshow").each(function(i){
			let arryH = [];
			$(this).find(".slideshow li").each(function(j){
				let _h = Math.floor( $(this).find("figure").height() + $(this).find(".slide_text").outerHeight() );
				arryH.push(_h);
				$(this).css({
					"height": _h + "px"
				});
			});
			$(this).find(".slideshow").css({
				"height": Math.max.apply(null, arryH) + "px"
			});
		});
	},
	nav: function(){
		var position,positionX,cx,touching;
		var idx = 0,
		limit = 80;
		var thisSlide;
		$(".wrap_slideshow").off().on({
			'touchstart': function(e) {
				idx = $(".wrap_slideshow").index(this);
				cx 			= 0;
				position 	= getPosition(e);
			},
			'touchmove': function(e) {
				//e.preventDefault();
				var touchX 	= event.touches[0].clientX;
				cx 	= position - getPosition(event);
			},
			'touchend': function(e) {
				if(cx < -limit){
					spotSlide.dec(idx);
				}else if(cx > limit){
					spotSlide.inc(idx);
				}
				cx = 0;
			},
			'touchcancel': function(e){
				cx = 0;
			}
		});
		function getPosition(event){
			return event.touches[0].pageX;
		}
		$(".wrap_slideshow").each(function(i){
			let $this = $(this);
			$this.find(".nav_slideshow li a").off().on("click", function(){
				spotslides[i].current = $this.find(".nav_slideshow li a").index($(this));
				spotSlide.change(i);
				console.log(spotslides[i].current);
			});
		})
	},
	inc: function(i){
		//console.log("inc", i, spotslides[i].current, spotslides[i].max)
		spotslides[i].current++;
		if(spotslides[i].current >= spotslides[i].max){
			spotslides[i].current = 0;
		}
		spotSlide.change(i);
	},
	dec: function(i){
		spotslides[i].current--;
		if(spotslides[i].current < 0){
			spotslides[i].current = spotslides[i].max-1;
		}
		spotSlide.change(i);
	},
	change: function(num){
		//console.log(num, spotslides[num].current)
		$(".wrap_slideshow").eq(num).find("ul li").removeClass("active");
		$(".wrap_slideshow").eq(num).find(".nav_slideshow ul li a").removeClass("active");
		$(".wrap_slideshow").eq(num).find("ul li").eq(spotslides[num].current).addClass("active");
		$(".wrap_slideshow").eq(num).find(".nav_slideshow ul li").eq(spotslides[num].current).find("a").addClass("active");
		
		/*
		if(num === $(".wrap_slideshow").length-1){
			clearInterval(spotSlidetimer);
			spotSlidetimer = setInterval(function(){
				$(".wrap_slideshow").each(function(i){
					spotSlide.inc(i);
				});
			}, spotSlide.duration);
		}
		*/
		/*$(".wrap_slideshow").each(function(i){
			clearInterval(spotslides[i].timer);
			spotslides[i].timer = setInterval(function(){
				console.log(i);
				spotSlide.inc(i);
			}, spotSlide.duration);
		});*/
	}
}
var mapApi = {
	isReady: false,
	init: function(){
		let lat = Number( $(".spot_map").attr("data-lat") );
		let lng = Number( $(".spot_map").attr("data-lng") );
		var LatLng = {lat: lat, lng: lng}
		var map = new google.maps.Map($(".gmap").get(0),{
			zoom: 15,
			center: LatLng,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			streetViewControl: false,
			scaleControl: false,
			zoomControl: true,
			overviewMapControl: false,
			mapTypeControl: false,
			panControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT
			},
			zoomControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT
			},
			mapTypeControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER
			},
			styles: [ ]
		});
		var marker = new google.maps.Marker({
			position: LatLng,
			map: map
		});
	}
}

var recommendSlide = {
	current: 0,
	max: 0,
	init: function(){
		recommendSlide.max = $(".slideshow_recommend ul.list_col1 li").length;
		recommendSlide.current = 0;
		//console.log(recommendSlide.current, recommendSlide.max);
		recommendSlide.resize();
		let navHTML = "";
		if(recommendSlide.max > 1){
			$(".slideshow_recommend ul.list_col1 li").each(function(i){
				navHTML += '<li><a href="javascript:void(0);">' + i + '</a></li>';
			});
			$(".block_recommend .nav_slideshow ul").html(navHTML);
		}
		setTimeout(function(){
			recommendSlide.nav();
			recommendSlide.resize();
		}, 500);
	},
	nav: function(){
		$("#recommend_next").off().on("click", function(){
			recommendSlide.inc();
		});
		$("#recommend_prev").off().on("click", function(){
			recommendSlide.dec();
		});
		$(".block_recommend .nav_slideshow li a").off().on("click", function(){
			let idx = $(".block_recommend .nav_slideshow li a").index(this);
			recommendSlide.current = idx;
			recommendSlide.change();
		});

		var position,positionX,cx,touching;
		var idx = 0,
		limit = 80;
		var thisSlide;
		$(".slideshow_recommend").off().on({
			'touchstart': function(e) {
				cx 			= 0;
				position 	= getPosition(e);
			},
			'touchmove': function(e) {
				//e.preventDefault();
				var touchX 		= event.touches[0].clientX;
				cx 	= position - getPosition(event);
			},
			'touchend': function(e) {
				if(cx < -limit){
					recommendSlide.dec();
				}else if(cx > limit){
					recommendSlide.inc();
				}
				cx = 0;
			},
			'touchcancel': function(e){
				cx = 0;
			}
		});
		function getPosition(event){
			return event.touches[0].pageX;
		}
	},
	inc: function(){
		recommendSlide.current++;
		if(recommendSlide.current >= recommendSlide.max){
			recommendSlide.current = recommendSlide.max-1;
		}else{
			recommendSlide.change();
		}
	},
	dec: function(){
		recommendSlide.current--;
		if(recommendSlide.current < 0){
			recommendSlide.current = 0;
		}else{
			recommendSlide.change();
		}
	},
	resize: function(){
		let _w = Math.floor( $(".slideshow_recommend_inner").width() );
		let arryH = [];
		$(".slideshow_recommend ul.list_col1 li").each(function(i){
			let _imgH = Math.floor( $(this).find(".img").outerHeight() );
			let _txtH = $(this).find(".ttl_col1").outerHeight();
			let _h = _imgH + _txtH;
			let _left = _w*i;
			$(this).css({
				"width": _w + "px",
				"left": _left + "px"
			});
			arryH.push(_h);
		});
		$(".slideshow_recommend ul.list_col1").css({
			"height": Math.max.apply(null, arryH) + "px"
		});
		recommendSlide.change();
	},
	change: function(){
		let _w = $(".slideshow_recommend_inner").width();
		$(".slideshow_recommend ul.list_col1").css({
			"transform": "translate3d(" + recommendSlide.current*-_w +  "px, 0,0)"
		});
		if(recommendSlide.current === 0){
			$("#recommend_prev").addClass("disable");
			$("#recommend_next").removeClass("disable");
		}else if(recommendSlide.current === recommendSlide.max - 1){
			$("#recommend_prev").removeClass("disable");
			$("#recommend_next").addClass("disable");
		}else{
			$("#recommend_prev").removeClass("disable");
			$("#recommend_next").removeClass("disable");
		}
		if(recommendSlide.max > 1){
		}else{
			$("#recommend_next").addClass("disable");
		}
		$(".slideshow_recommend .nav_slideshow li a").removeClass();
		$(".slideshow_recommend .nav_slideshow li").eq(recommendSlide.current).find("a").addClass("active");
	}
}